import '../../App.css';
import { Button } from 'react-bootstrap';
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { Container, Alert, Form} from 'react-bootstrap';

import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";

import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend';

import {Branding} from '../../services/misc';

const Info = () => {
  const [InstanceVerifyGUID, setInstanceVerifyGUID] = useState(window.location.pathname.replace('/Instance/Verify/',''));

  const [resultText, setResultText] = useState(":)");
  const [resultVariant, setResultVariant] = useState("success");
  const [resultVisible, setResultVisible] = useState(false);
  const [spinnerHidden, setSpinnerHidden] = useState(false);
  const [showButton, setShowButton] = useState(false);

  async function handleSubmit(e) {
    setSpinnerHidden(false);
    setResultVisible(true);

    var formDataObj = {SystemID:"NS", VerifyGUID : InstanceVerifyGUID};  
    let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI("/backend/instance/Verify","POST", JSON.stringify(formDataObj))
    
    setResultVariant(resultVariant);      
    setResultText(resultText);        
    setSpinnerHidden(true);
    setResultVisible(true);
    if (errorsException===false) setShowButton(true);
  }

  useEffect(async () => (window.onload = await handleSubmit), []);  

  return (
    <ContentWrapper>
    <Container>
    <Sida>
        <Rubrik>Verifiera konto</Rubrik>

        <Form.Group className="mb-3"  hidden={spinnerHidden}>
          <SpinnerX  />
        </Form.Group>                                      

        <Form.Group className="mb-3"  hidden={!resultVisible}>
          <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
          {showButton && <Link to="/login"><Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary">Inloggning</Button></Link>}
        </Form.Group>          

    </Sida>
    </Container>
    </ContentWrapper>
  );
};

export default Info;